// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Invoice'" tab="true"></sub-header>

  <branches-list detail-link="/#!/admin/invoice-branches"></branches-list>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/official-receipt-booklet/branches/official-receipt-booklet-branches.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;